import type { EnvironmentType } from "@taskfortress/core"
// Environment configuration for the mobile app
import Constants from "expo-constants"

// Helper function to convert releaseChannel to our standardized environment type
const getEnvironmentType = (): EnvironmentType => {
  // Safe access to releaseChannel with type assertion
  const releaseChannel = (Constants.expoConfig as any)?.releaseChannel as
    | string
    | undefined

  if (releaseChannel === "production") return "production"
  if (releaseChannel === "staging" || releaseChannel === "test")
    return "staging"
  return "development"
}

// Get the environment variables from Expo's extra config
// These are set in app.config.js and loaded as Constants.expoConfig.extra
const extraConfig = Constants.expoConfig?.extra || {}

const env = {
  api: {
    baseUrl: extraConfig.apiUrl || "http://localhost:3000",
  },
  analytics: {
    enabled: extraConfig.analyticsEnabled === true,
    matomoUrl: extraConfig.matomoUrl || "",
    matomoSiteId: parseInt(extraConfig.matomoSiteId || "1", 10),
    environment: getEnvironmentType(),
  },
}

// Export as a frozen object to prevent modifications
export default Object.freeze(env)
